import {AuthenticationDetails, CognitoUser, CognitoUserPool} from 'amazon-cognito-identity-js';


export const isSessionValid = (poolData) => {
    let sessionValid = true
    const userpool=new CognitoUserPool(
            poolData
        );
    const user = userpool.getCurrentUser()
    if (!user) sessionValid = false
    if (user) {
      user.getSession((err, session) => {
        if (err) sessionValid = false
      })
    }
    return sessionValid
}

export const authenticate=(username, password, userpool)=>{
    return new Promise((resolve, reject)=>{
        const user=new CognitoUser({
            Username: username,
            Pool: userpool
        });

        const authDetails= new AuthenticationDetails({
            Username: username,
            Password: password
        });

        user.authenticateUser(authDetails,{
            onSuccess:(result)=>{
                sessionStorage.setItem('token', result.getIdToken().jwtToken)
                resolve(result);
            },
            onFailure:(err)=>{
                reject(err);
            },
            mfaRequired: function (secretCode) {
                const mfaCode = prompt('Please enter OTP code sent to phone number');
                if (!mfaCode) {
                  alert('retry login');
                  return;
                }
                // `this` means calllback of `authenticateUser()`
                user.sendMFACode(mfaCode, this);
            },
        })
    });
};

export const logout = (userpool) => {
    const user = userpool.getCurrentUser();
    user.signOut();
    window.location.href = '/';
};
